<template>
  <div class="menu-item-r">
    <div class="dash-form-container">
      <div class="v-nav-wrap">
        <el-button class="el-button--primary-empty" type="primary" size="small" @click="$router.push('/my-exhibit-list')">{{
          $t('My Exhibit List')
        }}</el-button>
      </div>
      <el-form :model="exhibitInfo" :rules="rules" :label-width="labelWidth" label-position="right" ref="exhibitForm" size="small">
        <div v-for="(item, index) in specialList" :key="item.id">
          <template v-if="item.keyword === 'icon'">
            <div class="formBg" :class="{'margin-t-0': index == 0}">
              <div class="flex flex-start align-start m-b-24">
                <div class="utils-title">{{ item.name || $t('Upload picture') }}</div>
                <div class="utils-subTitle">
                  <p class="t">{{ $t('exhformTisp1') }}</p>
                  <p class="t2">{{ $t('exhformTisp2') }}</p>
                </div>
              </div>
              <div class="tip-block-example">
                <div class="icondiv">
                  <div>
                    <h4 class="h4 font-size-12">{{ $t('exhformTisp3') }}</h4>
                    <div class="tips font-size-12">
                      <template v-if="language == 'en'">
                        <img :src="tipsEn" />
                      </template>
                      <template v-else>
                        <img :src="tips" />
                      </template>
                    </div>
                  </div>
                  <div class="flex flex-start">
                    <div class="iconTips">
                      <div>
                        <img :src="exhibitFormTips1" />
                      </div>
                      <div class="margin-t-12 utils-tips2 h5 font-size-12">{{ $t('exhformTisp4') }}</div>
                    </div>
                    <div class="iconTips">
                      <div>
                        <img :src="exhibitFormTips2" />
                      </div>
                      <div class="margin-t-12 utils-tips2 h5 font-size-12">{{ $t('exhformTisp5') }}</div>
                    </div>
                    <div class="iconTips">
                      <div>
                        <img :src="exhibitFormTips3" />
                      </div>
                      <div class="margin-t-12 utils-tips2 h5 font-size-12">{{ $t('exhformTisp6') }}</div>
                    </div>
                    <div class="iconTips">
                      <div>
                        <img :src="exhibitFormTips4" />
                      </div>
                      <div class="margin-t-12 utils-tips2 h5 font-size-12">{{ $t('exhformTisp7') }}</div>
                    </div>
                  </div>
                </div>
                <div class="separate"></div>
                <div class="flex flex-start">
                  <div class="warning font-size-12 utils-tips"><i class="el-icon-warning"></i>{{ $t('exhformTisp') }}</div>
                  <div>
                    <p class="utils-tips font-size-12 warning">{{ $t('exhformTisp9') }}</p>
                    <p class="utils-tips font-size-12 warning">{{ $t('exhformTisp10') }}</p>
                  </div>
                </div>
              </div>

              <el-form-item label-width="0" :prop="item.keyword" class="picture-form-item">
                <div class="image-list1">
                  <div class="button-group">
                    <el-button
                      type="primary"
                      size="mini"
                      icon="el-icon-circle-plus-outline"
                      :disabled="exhibitInfo.icon.length >= 10"
                      @click="uploadFile('uploadImg')"
                      >{{ $t('Upload picture') }}</el-button
                    >
                  </div>
                  <div class="upload-image-container" :class="{'margin-t-24': (exhibitInfo.icon.length > 0 ) }">
                    <DashUploadMore ref="uploadImg" :uploadBtn="false" :limit="10" :mediaUrl.sync="exhibitInfo.icon"></DashUploadMore>
                  </div>
                </div>
              </el-form-item>
            </div>
          </template>

          <template v-if="item.keyword === 'videoUrl'">
            <div class="formBg">
              <div class="flex flex-start align-start m-b-24">
                <div class="utils-title">{{ item.name || $t('Upload video') }}</div>
                <div class="utils-subTitle">
                  <p class="t">{{ $t('exhformTisp11') }}</p>
                  <p class="t2">{{ $t('exhformTisp12') }}</p>
                </div>
              </div>
              <div class="tip-block-example">
                <div class="flex flex-start align-start">
                  <div class="videoDiv iconTips">
                    <div class="videotips">
                      <template v-if="language == 'en'">
                        <img :src="tipsEn" />
                      </template>
                      <template v-else>
                        <img :src="tips" />
                      </template>
                    </div>
                    <div>
                      <img :src="exhibitFormTips5" />
                    </div>
                    <div class="margin-t-12 utils-tips2 h5 font-size-12">{{ $t('exhformTisp13') }}</div>
                  </div>
                  <div class="videoDiv iconTips">
                    <div class="videotips">
                      <template v-if="language == 'en'">
                        <img :src="tipsEn" />
                      </template>
                      <template v-else>
                        <img :src="tips" />
                      </template>
                    </div>
                    <div>
                      <img :src="exhibitFormTips6" />
                    </div>
                    <div class="margin-t-12 utils-tips2 h5 font-size-12">{{ $t('exhformTisp14') }}</div>
                  </div>
                </div>
                <div class="separate"></div>
                <div class="flex flex-start">
                  <div class="warning font-size-12 utils-tips"><i class="el-icon-warning"></i>{{ $t('exhformTisp') }}</div>
                  <div>
                    <p class="utils-tips font-size-12 warning">{{ $t('exhformTisp15') }}</p>
                    <p class="utils-tips font-size-12 warning">{{ $t('exhformTisp16') }}</p>
                    <p class="utils-tips font-size-12 warning">{{ $t('exhformTisp17') }}</p>
                  </div>
                </div>
              </div>
              <el-form-item label-width="0" :prop="item.keyword">
                <div class="button-grou">
                  <el-button
                    :type="uploadFileStatus == 1 ? 'primary' : ''"
                    size="mini"
                    icon="el-icon-circle-plus-outline"
                    @click="uploadFile('uploadVideo', 1)"
                    >{{ $t('Upload video') }}</el-button
                  >
                  <el-button
                    :type="uploadFileStatus == 2 ? 'primary' : ''"
                    size="mini"
                    icon="el-icon-circle-plus-outline"
                    @click="uploadFile('uploadPreviewImage', 2)"
                    >{{ $t('finds.uploadVideoImg') }}</el-button
                  >
                </div>
                <div class="upload-image-container" :class="{'margin-t-24': (exhibitInfo['videoUrl'].length > 0 && uploadFileStatus == 1) || (exhibitInfo['previewImageUrl'].length>0 && uploadFileStatus == 2) }">
                  <DashUploadMore
                    ref="uploadVideo"
                    v-show="uploadFileStatus === 1"
                    :limit="1"
                    :media="'video'"
                    :uploadBtn="false"
                    :mediaUrl.sync="exhibitInfo[item.keyword]"
                  ></DashUploadMore>

                  <DashUploadMore
                    ref="uploadPreviewImage"
                    v-show="uploadFileStatus === 2"
                    :limit="1"
                    :uploadBtn="false"
                    :mediaUrl.sync="exhibitInfo['previewImageUrl']"
                  ></DashUploadMore>
                </div>
              </el-form-item>
            </div>
          </template>

          <template v-if="item.keyword === 'questionList'">
            <div class="formBg">
              <div class="flex flex-start align-start">
                <div class="utils-title">{{ $t('Add product tags') }}</div>

                <div class="utils-subTitle">
                  <p class="t">{{ $t('exhformTisp18') }}</p>
                </div>
              </div>

              <TagSelection ref="tag-selection"
                :showTips="true" 
                :types="'PRODUCT_PUBLISH'" 
                :limitedAmountList="language == 'en' ? {
                  '20111baoliqiuji': 3,
                  '20121baoliqiuji': 1,
                  '20131baoliqiuji': 1,
                } : {
                  '2011baoliqiuji': 3,
                  '2012baoliqiuji': 1,
                  '2013baoliqiuji': 1
                }" 
                :answerList="exhibitInfo.questionList || []" />
            </div>
          </template>
        </div>

        <el-row class="formBg">
          <div v-for="(item, index) in list" :key="item.id">
            <div class="utils-title" v-if="index === 0">
              {{ $t('Add form data') }}
            </div>
            <el-col :xs="24" :sm="24" :md="24" v-if="$config.form.textareaFields.indexOf(item.keyword) > -1">
              <el-form-item :label="item.name" :prop="item.keyword">
                <el-input
                  type="textarea"
                  rows="4"
                  :placeholder="item.placeholder"
                  v-model="exhibitInfo[item.keyword]"
                  :maxlength="item.inputLength || 200"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col v-else :xs="24" :sm="12" :md="12">
              <el-form-item :label="item.name" :prop="item.keyword">
                <template v-if="item.canSelect && item.keyword === 'scope'">
                  <el-select
                    v-model="exhibitInfo[item.keyword]"
                    :placeholder="item.placeholder"
                  >
                    <el-option :label="$t('common.allLook')" :value="0"></el-option>
                    <el-option :label="$t('common.onlyPreRegistered2')" :value="2"></el-option>
                    <!-- <el-option :label="$t('common.onlyLook2')" :value="1"></el-option> -->
                  </el-select>
                </template>

                <template v-if="item.canSelect && item.keyword !== 'scope'">
                  <el-select v-model="exhibitInfo[item.keyword]" :placeholder="item.placeholder">
                    <template v-if="item.keyword == 'productIdentification'">
                      <el-option :label="$t('Yes')" :value="'true'"></el-option>
                      <el-option :label="$t('No')" :value="'false'"></el-option>
                    </template>
                    <template v-else>
                      <el-option :label="$t('Yes')" :value="true"></el-option>
                      <el-option :label="$t('No')" :value="false"></el-option>
                    </template>
                  </el-select>
                </template>

                <template v-if="!item.canSelect">
                  <el-input
                    :placeholder="item.placeholder"
                    v-model="exhibitInfo[item.keyword]"
                    :maxlength="item.inputLength || 200"
                    show-word-limit
                    :class="{ 'input-with-select': $config.form.httpFields.indexOf(item.keyword) > -1 }"
                  >
                    <el-select v-model="exhibitInfo[item.keyword + '_http']" slot="prepend" v-if="$config.form.httpFields.indexOf(item.keyword) > -1">
                      <el-option v-for="item in $t('select.httpOptions')" :key="item.label" :value="item.value"></el-option>
                    </el-select>
                  </el-input>
                </template>
              </el-form-item>
            </el-col>
          </div>
        </el-row>
        <div v-for="(item, index) in specialList" :key="index">
          <template v-if="item.keyword === 'piiic'">
            <div class="formBg">
              <div class="flex flex-start align-start m-b-24">
                <div class="utils-title">{{ item.name || $t('Upload long picture') }}</div>
                <div class='utils-subTitle'>
                  <p class="t">{{ $t('exhformTisp19') }}</p>
                  <p class="t2">{{ $t('exhformTisp20') }}</p>
                </div>
              </div>
              <div class='tip-block-example'>
                <div class="piiicdiv">
                  <div>
                    <h4 class="h4 font-size-12">{{ $t('exhformTisp21') }}</h4>
                    <div class="piiictips font-size-12">
                      <template v-if="language == 'en'">
                        <img :src="tipsEn" />
                      </template>
                      <template v-else>
                        <img :src="tips" />
                      </template>
                    </div>
                  </div>
                  <div class="flex flex-start">
                    <div class="piiicTips">
                      <img :src="exhibitFormTips7" />
                    </div>
                    <div class="piiicTips">
                      <img :src="exhibitFormTips8" />
                    </div>
                    <div class="piiicTips">
                      <img :src="exhibitFormTips9" />
                    </div>
                    <div class="piiicTips">
                      <img :src="exhibitFormTips10" />
                    </div>
                  </div>
                </div>
                <div class="separate"></div>
                <div class="flex flex-start">
                  <div class="warning font-size-12 utils-tips"><i class="el-icon-warning"></i>{{ $t('exhformTisp') }}</div>
                  <div>
                    <p class="utils-tips font-size-12 warning">{{ $t('exhformTisp22') }}</p>
                    <p class="utils-tips font-size-12 warning">{{ $t('exhformTisp23') }}</p>
                  </div>
                </div>
              </div>
              <el-form-item label-width="0" :prop="item.keyword" class="picture-form-item">
                <div class="button-group">
                  <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-circle-plus-outline"
                    :disabled="exhibitInfo.piiic.length >= 100"
                    @click="uploadFile('piiicImg')"
                    >{{ $t('Upload picture') }}</el-button
                  >
                </div>
                <div class="image-list1" :class="{'margin-t-24': (exhibitInfo['piiic'].length > 0) }">
                  <DashUploadMore
                    ref="piiicImg"
                    :uploadBtn="false"
                    :limit="100"
                    :types="'piiic'"
                    :mediaUrl.sync="exhibitInfo['piiic']"
                  ></DashUploadMore>
                </div>
                <el-checkbox-group v-model="exhibitInfo.piiic" v-show="false"></el-checkbox-group>
              </el-form-item>
            </div>
          </template>
        </div>
      </el-form>
      <div class="form-submit-block" v-if="exhibitInit">
        <el-button class="dash-submit btn-544" :loading="loading" @click="validateForm('exhibitForm')" type="primary">{{
          $t('Confirm and publish')
        }}</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { updateExhibit, getProductDetail, getFetchList } from '@/api'
import { mapGetters } from 'vuex'
import { validateFn, validImagesLength } from '@/utils/validate'
import exhibitFormTips1 from '../../../src/assets/images/exhibitFormTips1.png'
import exhibitFormTips2 from '../../../src/assets/images/exhibitFormTips2.png'
import exhibitFormTips3 from '../../../src/assets/images/exhibitFormTips3.png'
import exhibitFormTips4 from '../../../src/assets/images/exhibitFormTips4.png'
import exhibitFormTips5 from '../../../src/assets/images/exhibitFormTips5.png'
import exhibitFormTips6 from '../../../src/assets/images/exhibitFormTips6.png'
import exhibitFormTips7 from '../../../src/assets/images/exhibitFormTips7.png'
import exhibitFormTips8 from '../../../src/assets/images/exhibitFormTips8.png'
import exhibitFormTips9 from '../../../src/assets/images/exhibitFormTips9.png'
import exhibitFormTips10 from '../../../src/assets/images/exhibitFormTips10.png'
import tips from '../../../src/assets/images/tips.png'
import tipsEn from '../../../src/assets/images/tipsEn.png'

import DashUploadMore from '@/components/DashUploadMore'
import TagSelection from '@/components/TagSelection'
export default {
  name: 'ExhibitForm',

  data() {
    return {
      showTagSelector: false,
      uploadFileStatus: 1,
      exhibitFormTips1: exhibitFormTips1,
      exhibitFormTips2: exhibitFormTips2,
      exhibitFormTips3: exhibitFormTips3,
      exhibitFormTips4: exhibitFormTips4,
      exhibitFormTips5: exhibitFormTips5,
      exhibitFormTips6: exhibitFormTips6,
      exhibitFormTips7: exhibitFormTips7,
      exhibitFormTips8: exhibitFormTips8,
      exhibitFormTips9: exhibitFormTips9,
      exhibitFormTips10: exhibitFormTips10,
      tips: tips,
      tipsEn: tipsEn,
      loading: false,
      labelWidth: this.$store.getters.language === 'en' ? '180px' : '130px',
      // 上传字段key
      specialFields: ['icon', 'videoUrl', 'piiic', 'questionList'],
      list: [],
      specialList: [],
      // 必选类别列表
      requestList: {
        'zh': {
          '2011baoliqiuji': true,
          '2012baoliqiuji': true,
          '2013baoliqiuji': true,
          '2020baoliqiuji': true,
          '2021baoliqiuji': true
        },
        'en': {
          '20111baoliqiuji': true,
          '20121baoliqiuji': true,
          '20131baoliqiuji': true,
          '20201baoliqiuji': true,
          '20211baoliqiuji': true
        }
      },
      // form data
      exhibitInfo: {
        previewImageUrl: '',
        website_http: 'http://'
      },
      rules: {},
      exhibitInit: false
    }
  },

  components: {
    DashUploadMore,
    TagSelection
  },
  computed: {
    ...mapGetters(['language'])
  },

  mounted() {
    this.getFormField()
  },

  methods: {
    // 获取form表单字段
    getFormField() {
      const loading = this.$loading()
      getFetchList()
        .then(res => {
          const fields = res.data.data.formFieldProductList
          if (res.data.code === 1000 && fields.length > 0) {
            // 上传，产品标签字段 && 排序
            this.specialFields.forEach(inputName => {
              fields.forEach(item => {
                if (item.keyword === inputName && this.specialFields.indexOf(item.keyword) !== -1) {
                  this.specialList.push(item)
                }
              })
            })

            // 非上传字段
            let list = []
            fields.forEach(item => {
              if (this.specialFields.indexOf(item.keyword) === -1) {
                list.push(item)
              }
            })
            /**
             * 给form赋值
             * 生成验证规则
             */
            fields.forEach(item => {
              switch (item.keyword) {
                case 'icon':
                  this.$set(this.exhibitInfo, item.keyword, [])
                  break
                case 'videoUrl':
                  this.$set(this.exhibitInfo, 'videoUrl', [])
                  this.$set(this.exhibitInfo, 'previewImageUrl', [])
                  break
                case 'piiic':
                  this.$set(this.exhibitInfo, item.keyword, [])
                  break
                default:
                  this.$set(this.exhibitInfo, item.keyword, '')
              }

              // 必填条件
              if (item.required && item.keyword) {
                if (!this.rules[item.keyword]) {
                  this.$set(this.rules, item.keyword, [])
                }
                if (item.keyword === 'icon' || item.keyword === 'piiic') {
                  let msg = this.$t('Please upload at least one picture')
                  if (item.keyword === 'piiic') {
                    msg = this.$t('Please upload at least one long picture')
                  }
                  this.rules[item.keyword].push({
                    validator: validateFn(validImagesLength),
                    message: msg,
                    trigger: 'change'
                  })
                } else {
                  this.rules[item.keyword].push({
                    required: true,
                    message: item.name + ' ' + this.$t('common.required'),
                    trigger: 'change'
                  })
                }
              }
            })

            this.list = list
            return true
          }
        })
        .then(() => {
          if (this.$route.params.id) {
            this.getDetail()
          }
        })
        .finally(() => {
          setTimeout(() => {
            loading.close()
          }, 500)
          this.exhibitInit = true
        })
    },

    getDetail() {
      const loading = this.$loading({
        lock: true
      })
      getProductDetail({
        id: this.$route.params.id,
        convertLanguage: false,
        showType: 'PRODUCT_DETAILS'
      }).then(res => {
        loading.close()
        const _exhInfo = res.data.data

        Object.keys(_exhInfo).forEach(key => {
          this.exhibitInfo[key] = _exhInfo[key]
          if (key === 'productEnName') {
            this.exhibitInfo['productEName'] = _exhInfo['productEnName']
          }
          if (key === 'productEnIntro') {
            this.exhibitInfo['productEIntro'] = _exhInfo['productEnIntro']
          }
          if (key === 'pdtBrand') {
            this.exhibitInfo['productBrand'] = _exhInfo['pdtBrand']
          }

          // 网址 回显
          if (this.$config.form.httpFields.indexOf(key) > -1) {
            let info = this.exhibitInfo[key]
            if (info && info.indexOf('http://') == 0) {
              this.exhibitInfo[key] = this.exhibitInfo[key].substr(7)
              this.exhibitInfo[key + '_http'] = 'http://'
            } else if (info && info.indexOf('https://') == 0) {
              this.exhibitInfo[key] = this.exhibitInfo[key].substr(8)
              this.exhibitInfo[key + '_http'] = 'https://'
            } else {
              this.exhibitInfo[key + '_http'] = 'http://'
            }
          }
        })

        this.exhibitInfo.icon = _exhInfo.iconUrl ? _exhInfo.iconUrl.split(',') : []
        this.exhibitInfo.piiic = _exhInfo.piiic ? _exhInfo.piiic.split(',') : []
        this.exhibitInfo.videoUrl = _exhInfo.videoUrl ? _exhInfo.videoUrl.split(',') : []
        this.exhibitInfo.previewImageUrl = _exhInfo.previewImageUrl ? _exhInfo.previewImageUrl.split(',') : []
        this.exhibitInfo.questionList = _exhInfo.questionList
      }).finally(() => {})
    },

    validateForm(formName) {
      /**
       * 判断 产品标签 在多选的时候
       * 是否必填
       */
      let qStatus = true
      if (this.$refs['tag-selection']) {
        let questionList = this.$refs['tag-selection'][0].getQuestionList()
        let tipList = this.$refs['tag-selection'][0].getTipsList()
        let qList = {}
        let isRequest = this.requestList[this.language]
        
        questionList.forEach(item => {
            qList[item.questionId] = item.answerIds.length
        })

        Object.keys(tipList).forEach(item => {
            if ((!qList[item] || qList[item] == 0) && isRequest[item]) {
            setTimeout(() => {
                this.$notify.error([this.$t('Product tags'), tipList[item], this.$t('common.required')].join(' '))
            }, 50)
            qStatus = false
            }
        })
      }
      
      if (!qStatus) return qStatus

      this.$refs[formName].validate(valid => {
        if (valid) {
          this.submitForm()
        } else {
          return false
        }
      })
    },

    // 获取表单提交的字段值
    getFormData() {
      let data = JSON.parse(JSON.stringify(this.exhibitInfo))
      data.actorId = this.$store.getters.exhibitorId

      if (data['productEnIntro'] !== undefined) {
        data['productEIntro'] = data['productEnIntro']
      }

      if (data.icon) {
        let list = data.icon.filter(item => item != '')
        data.icon = list.join(',')
      }
      if (data.piiic) {
        let list = data.piiic.filter(item => item != '')
        data.piiic = list.join(',')
      }
      if (data.videoUrl) {
        let list = data.videoUrl.filter(item => item != '')
        data.videoUrl = list.join(',')
      }
      if (data.previewImageUrl) {
        let list = data.previewImageUrl.filter(item => item != '')
        data.previewImageUrl = list.join(',')
      }

      data.showType = 'PRODUCT_PUBLISH' // 标签展示位置

      // get questionList from tagSelection
      if (this.$refs['tag-selection']) {
        data.questionList = this.$refs['tag-selection'][0].getQuestionList()
      }

      if (this.exhibitInfo.id) {
        data.id = this.exhibitInfo.id
      }

      for (let key in data) {
        if (this.$config.form.httpFields.indexOf(key) > -1 && data[key]) {
          data[key] = this.exhibitInfo[key + '_http'] + data[key]
        }
      }

      return data
    },

    submitForm() {
      this.loading = true
      console.log(this.exhibitInfo)
      if(this.exhibitInfo.previewImageUrl.length == 0 && this.exhibitInfo.videoUrl.length != 0) {
        this.$notify({
          message: this.$t('Please upload a cover image of the video while uploading the video. Otherwise the front-end display will be blank.'),
          type: 'warning'
        });
        this.loading = false
        return false
      }
      if(this.exhibitInfo.previewImageUrl.length != 0 && this.exhibitInfo.videoUrl.length == 0) {
        this.$notify({
          message: this.$t('Please upload Video.'),
          type: 'warning'
        });
        this.loading = false
        return false
      }
      updateExhibit(this.getFormData())
        .then(res => {
          if (res.data.code === 1000) {
            this.$router.push('/my-exhibit-list')
          } else {
            this.$message(res.data.message)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 图片上传功能（照片，视频，封面图）
    uploadFile(name, status) {
      if (status !== undefined) {
        this.uploadFileStatus = status
      }

      if ((status === 1 && this.exhibitInfo['videoUrl'].length == 1) || (status === 2 && this.exhibitInfo['previewImageUrl'].length == 1)) {
        return
      }

      this.$nextTick(() => {
        this.$refs[name][0].uploadAdd()
      })
    },
    // 获取imgList（布局使用）
    getImgArr() {
      var icon = JSON.parse(JSON.stringify(this.exhibitInfo.icon))
      icon = icon.filter(d => {
        return d != '' && d
      })
      return icon
    }
  }
}
</script>
<style lang="stylus" scoped>
.dash-form-container {
  padding-bottom: 60px;
  margin: 30px auto;
  background $color-white
  .formBg{
    background $color-gray-fb
    padding 24px 15px
    margin 16px 0
  }

  .image-list1{
    .dash-upload{
      margin-right 15px
    }
  }

  .videoDiv{
    width 293px
    min-height 261px;
    border 2px dashed $color-main
    border-radius: 2px;
    padding 16px
    position relative
  }
  .piiicdiv{
    width 886px
    min-height 546px;
    border 2px dashed $color-main
    border-radius: 2px;
    padding 16px
    position relative

  }
  .piiicTips{
    margin-right 24px
    img {
      width 195px
      height 481px
    }
  }
}
</style>
